import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TemplateVersionDecision, TemplateVersionDecisionType } from '../../../../../models/template-version/template-version.interface';
import { DECISION_TYPES, decisionCounts, decisionType } from '../review-utils';

@Component({
  selector: 'app-review-decisions-v2',
  imports: [CommonModule, FormsModule],
  templateUrl: './review-decisions-v2.component.html',
  styleUrl: './review-decisions-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewDecisionsV2Component {
  @Input() decisions: TemplateVersionDecision[] = [];

  @Output() submitDecision = new EventEmitter<{ type: TemplateVersionDecisionType; comment: string | null }>();

  open = false;
  formOpen = false;
  selectedType: TemplateVersionDecisionType | null = null;
  comment = '';

  readonly types = DECISION_TYPES;

  get counts(): { red: number; amber: number; green: number } {
    return decisionCounts(this.decisions);
  }

  typeOf(d: TemplateVersionDecision): { key: TemplateVersionDecisionType; label: string; tone: 'green' | 'amber' | 'red' | 'grey' } {
    return decisionType(d.type);
  }

  authorOf(d: TemplateVersionDecision): string {
    const user = d.createdBy;
    return user?.name || user?.username || '';
  }

  submit(): void {
    if (!this.selectedType) return;
    this.submitDecision.emit({
      type: this.selectedType,
      comment: this.comment.trim() || null,
    });
    this.formOpen = false;
    this.selectedType = null;
    this.comment = '';
    this.open = true;
  }

  cancel(): void {
    this.formOpen = false;
    this.selectedType = null;
    this.comment = '';
  }
}
